export const reduxKey = '@@notificationsQueue';
export const actionKey = '@@NOTIFICATIONS';

//# sourceMappingURL=constants.js.map